var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleTool(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2751_121570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50016 7.49998H17.5002C18.4207 7.49998 19.1668 6.75379 19.1668 5.83331V2.49998C19.1668 1.5795 18.4207 0.833313 17.5002 0.833313H2.50016C1.57969 0.833313 0.833496 1.5795 0.833496 2.49998V17.5C0.833496 18.4205 1.57969 19.1666 2.50016 19.1666H5.8335C6.75397 19.1666 7.50016 18.4205 7.50016 17.5V7.49998ZM5.8335 14.1666V11.6666H5.00016C4.53993 11.6666 4.16683 11.2936 4.16683 10.8333C4.16683 10.3731 4.53993 9.99998 5.00016 9.99998H5.8335V7.49998H5.00016C4.53993 7.49998 4.16683 7.12688 4.16683 6.66665C4.16683 6.20641 4.53993 5.83331 5.00016 5.83331H5.8335V4.99998C5.8335 4.53975 6.2066 4.16665 6.66683 4.16665C7.12706 4.16665 7.50016 4.53975 7.50016 4.99998V5.83331H10.0002V4.99998C10.0002 4.53975 10.3732 4.16665 10.8335 4.16665C11.2937 4.16665 11.6668 4.53975 11.6668 4.99998V5.83331H14.1668V4.99998C14.1668 4.53975 14.5399 4.16665 15.0002 4.16665C15.4604 4.16665 15.8335 4.53975 15.8335 4.99998V5.83331H16.6668C17.1271 5.83331 17.5002 5.46021 17.5002 4.99998V3.33331C17.5002 2.87308 17.1271 2.49998 16.6668 2.49998H3.3335C2.87326 2.49998 2.50016 2.87308 2.50016 3.33331V16.6666C2.50016 17.1269 2.87326 17.5 3.3335 17.5H5.00016C5.4604 17.5 5.8335 17.1269 5.8335 16.6666V15.8333H5.00016C4.53993 15.8333 4.16683 15.4602 4.16683 15C4.16683 14.5397 4.53993 14.1666 5.00016 14.1666H5.8335Z",
    fill: "#717784",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_121570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleTool);
export default __webpack_public_path__ + "static/media/angleTool.da229ad203d3d28e6dfb6d3b12768e14.svg";
export { ForwardRef as ReactComponent };